const WarehouseValidation = (values) => {
  let errors = {};
  if (values._name === "") {
    errors._name = "Please Enter Warehouse Name ";
  }
  return errors;
};
export default WarehouseValidation;
